// Translation for fi
export const fi = {
        common: {
            save: 'Tallenna',
            cancel: 'Peruuta',
            close: 'Sulje',
            delete: 'Poista',
            edit: 'Muokkaa',
            activate: 'Aktivoi',
            add: 'Lisää',
            saving: 'Tallennetaan...',
            loading: 'Ladataan...',
            active: 'AKTIIVINEN',
            inUse: 'Käytössä',
            test: 'Testaa',
            searchApps: 'Etsi sovelluksia...',
            betaBanner: 'BETA - Palvelu ei ole vielä saatavilla!'
        },
        header: {
            creditBalance: 'Saldo',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Kirjaudu Sisään',
            signUp: 'Rekisteröidy',
            username: 'Käyttäjänimi',
            password: 'Salasana',
            continue: 'Jatka',
            noAccount: 'Eikö sinulla ole tiliä?',
            hasAccount: 'Onko sinulla jo tili?',
            loginError: 'Kirjautuminen epäonnistui',
            invalidCredentials: 'Virheellinen käyttäjänimi tai salasana',
            rateLimited: 'Liian monta kirjautumisyritystä. Odota hetki.',
            sessionExpired: 'Istuntosi on vanhentunut. Käytä uutta taikaliinkiä.',
            magicLinkInvalid: 'Kirjautumislinkki on virheellinen tai vanhentunut.',
            magicLinkSuccess: 'Tervetuloa! Sinut kirjattiin sisään onnistuneesti.',
            magicLinkProcessing: 'Käsitellään kirjautumista...',
            connectionError: 'Yhteysvirhe. Yritä uudelleen.'
        },
        profile: {
            myProgress: 'Minun Oppimisen Edistyminen',
            signOut: 'Kirjaudu Ulos',
            plan: 'Suunnitelma: '
        },
        settings: {
            title: 'Asetukset',
            tabs: {
                uiSettings: 'UI-asetukset',
                systemPrompt: 'Järjestelmäkehote',
                llmProfiles: 'LLM-profiilit',
                ttsProfiles: 'TTS-profiilit',
                language: 'Kieli',
            },
            uiSettings: {
                title: 'Käyttöliittymä',
                themeMode: 'Teeman Tila',
                darkMode: 'Tumma Tila',
                lightMode: 'Vaalea Tila',
                themeColor: 'Teeman Väri',
                themeColorDesc: 'Valitse painikkeiden, kuvakkeiden ja korostuksien painotusväri',
                background: 'Tausta',
                backgroundDesc: 'Valitse työtilan tausta',
                selectBackgroundColor: 'Valitse Taustavaami',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Keskittyminen',
                    concentration: 'Keskittyminen',
                    relaxation: 'Rentoutuminen',
                    lianas: 'Liaanat',
                    color: 'Väri'
                },
                backgroundColors: {
                    deepDark: 'Syvän Musta',
                    darkGrey: 'Tumma Harmaa',
                    midnightBlue: 'Puoliyön Sininen',
                    indigo: 'Indigo',
                    darkTeal: 'Tumma Sinivihreä',
                    brown: 'Ruskea',
                    darkRed: 'Tumma Punainen',
                    deepPurple: 'Syvän Violetti',
                    pureWhite: 'Puhdas Valkoinen',
                    softWhite: 'Pehmeä Valkoinen',
                    lightGrey: 'Vaalea Harmaa',
                    paleBlue: 'Kalpea Sininen',
                    paleGreen: 'Kalpea Vihreä',
                    paleOrange: 'Kalpea Oranssi',
                    lavender: 'Laventeli',
                    blueGrey: 'Siniharmaa'
                }
            },
            systemPrompt: {
                label: 'Järjestelmäkehote:',
                placeholder: 'Ladataan järjestelmäkehötettä...',
                emptyError: 'Järjestelmäkehote ei voi olla tyhjä!',
                saveSuccess: '✓ Järjestelmäkehote tallennettu onnistuneesti!',
                loadError: 'Virhe järjestelmäkehoitteen lataamisessa',
                saveError: 'Virhe tallennuksessa'
            },
            llmProfiles: {
                addButton: '+ Lisää Uusi Yhteys',
                newConnection: 'Uusi Yhteys',
                editConnection: 'Muokkaa Yhteyttä',
                emptyState: 'Ei LLM-yhteyksiä saatavilla. Klikkaa alla lisätäksesi yhden.',
                loadingProfiles: 'Ladataan profiileja...',
                nameLabel: 'Nimi *',
                namePlaceholder: 'esim. OpenAI GPT-4',
                apiUrlLabel: 'API-URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API-avain *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Malli *',
                modelPlaceholder: 'gpt-4, mistral-tiny, jne.',
                allFieldsRequired: 'Kaikki kentät on täytettävä!',
                saveSuccess: '✓ Profiili tallennettu onnistuneesti!',
                deleteConfirm: 'Haluatko varmasti poistaa "{name}"?',
                profileNotFound: 'Profiilia ei löytynyt!',
                loadError: 'Virhe profiilien lataamisessa',
                saveError: 'Virhe tallennuksessa',
                activateError: 'Virhe aktivoinnissa',
                deleteError: 'Virhe poistamisessa',
                modelInfo: 'Malli: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Lisää Uusi Ääni',
                newVoice: 'Uusi Ääni',
                editVoice: 'Muokkaa Ääntä',
                emptyState: 'Ei TTS-profiileja saatavilla. Klikkaa alla lisätäksesi yhden.',
                loadingProfiles: 'Ladataan TTS-profiileja...',
                nameLabel: 'Nimi',
                namePlaceholder: 'esim. Minun ElevenLabs Adam',
                providerLabel: 'Toimittaja',
                providerPlaceholder: 'esim. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Paikallinen)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API-URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API-avain *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'Mallin ID *',
                modelIdPlaceholder: 'esim. eleven_monolingual_v1',
                voiceIdLabel: 'Äänen ID',
                voiceIdPlaceholder: 'esim. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'Kaikki kentät on täytettävä!',
                saveSuccess: '✓ TTS-profiili tallennettu onnistuneesti!',
                deleteConfirm: 'Haluatko varmasti poistaa "{name}"?',
                loadError: 'Virhe TTS-profiilien lataamisessa',
                saveError: 'Virhe tallennuksessa',
                activateError: 'Virhe aktivoinnissa',
                deleteError: 'Virhe poistamisessa'
            },
            language: {
                title: 'Valitse Kieli',
                description: 'Valitse käyttöliittymän haluamasi kieli'
            },
        },
        chat: {
            ready: 'Valmis',
            start: 'ALOITA',
            stop: 'PYSÄYTÄ',
            initialMessage: 'Klikkaa ALOITA reaaliaikaiselle keskustelulle.',
            listening: 'Kuuntelen...',
            speaking: 'Thorsten puhu...',
            userLabel: 'Sinä',
            aiLabel: 'Tekoäly',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Kirjoita viesti...',
            send: 'Lähetä',
            loginRequired: 'Kirjaudu sisään käyttääksesi tätä palvelua.',
            loginButton: 'Kirjaudu Sisään Nyt',
            magicLinkRequired: 'Käytä taikaliinkiä kirjautumiseen.',
            creditLimitError: 'Tunti-kiintiösi on käytetty loppuun. Päivitä suunnitelmaasi (Medium/Premium) jatkaaksesi.',
            serviceDisabled: 'Chat-palvelu ei ole tällä hetkellä käytettävissä. Yritä myöhemmin uudelleen.'
        },
        notifications: {
            error: 'Virhe',
            success: 'Onnistui',
            info: 'Tieto',
            unknownError: 'Tapahtui tuntematon virhe'
        },
        cookie: {
            message: 'Tämä verkkosivusto käyttää evästeitä tarjotakseen sinulle parhaan mahdollisen käyttökokemuksen.',
            accept: 'Hyväksy'
        },
        curriculum: {
                buttonLabel: 'Opetussuunnitelma',
                buttonTitle: 'Näytä opetussuunnitelman sisältö',
                modalTitle: '{app} Opetussuunnitelma',
                sections: {
                    topic: 'Opetussuunnitelman aihe',
                    explanation: 'Lapsiystävällinen selitys',
                    studentProfile: 'Oppilasprofiili'
                },
                topic: {
                    empty: 'Tähän mikrosovellukseen ei ole linkitetty opetussuunnitelman aihetta taustajärjestelmässä.',
                    missingDetail: 'Yksityiskohtaisia opetussuunnitelmatietoja tälle mikrosovellukselle ei ole vielä saatavilla taustajärjestelmässä.',
                    learningGoals: 'Oppimistavoitteet',
                    prerequisites: 'Edellytykset',
                    unitLabel: 'Yksikkö',
                    durationLabel: 'Kesto',
                    difficultyLabel: 'Vaikeustaso',
                    hours: 't',
                    minutes: 'min'
                },
                explanation: {
                    empty: 'Lapsiystävällistä selitystä ei ole saatavilla.',
                    loadingPrepare: 'Tekoäly valmistelee selitystä',
                    loadingExplain: 'Tekoäly selittää aihetta lapsiystävällisellä kielellä',
                    requestFailed: 'Lapsiystävällistä selitystä ei voitu luoda.'
                },
                studentProfile: {
                    country: 'Maa',
                    region: 'Osavaltio / Alue',
                    schoolType: 'Koulutyyppi',
                    grade: 'Luokka-aste',
                    noContext: 'Oppilaskontekstia ei ole saatavilla.',
                    childProfileNotFound: 'Nykyiselle kirjautumiselle ei löytynyt oppilasprofiilia taustajärjestelmästä.',
                    loginProfileIncomplete: 'Kirjautumisprofiili ei vielä sisällä täydellistä oppilaskontekstia.',
                    educationContextNotFound: 'Oppilasprofiili löytyi, mutta opetussuunnitelman määritystä ei ole asetettu.',
                    noToken: 'Kirjautunutta oppilasta ei löytynyt.'
                },
                errors: {
                    signInRequired: 'Kirjaudu sisään nähdäksesi opetussuunnitelman.',
                    appIdMissing: 'Sovelluksen tunnus puuttuu.',
                    loadFailed: 'Opetussuunnitelman tietoja ei voitu ladata.'
                }
            }
    };
